// import { ContentRow } from './components/ContentRow.js';
// import { ContentRowsWrapper } from './components/ContentRowsWrapper.js';
import { CloudinaryImage } from '#src/components/CloudinaryImage/index.js';
import { flattenImageAsset } from '#src/lib/contentful/selectors.mjs';
import { requireAuthOrProspectEmail } from '#src/lib/routes/guards';

import CtaButton from './components/CtaButton';
import { Card } from './components/Card.js';
import ComposableCallout from './components/ComposableCallout.js';
import { Feature } from './components/Feature/Feature.js';
import { Footer } from './components/Footer.js';
import { Header } from './components/Header.js';
import { PageWrapper } from './components/PageWrapper.js';
import { PressLogos } from './components/PressLogos.js';
import { ProductHero } from './components/ProductHero.js';
import { WaybetterWay } from './components/WaybetterWay.js';
import { HeaderText } from './components/HeaderText';
import { ResponsiveHeroImage } from './components/ResponsiveHeroImage.js';
import { Stats } from './components/Stats.js';
import { TestimonialCarousel } from './components/TestimonialCarousel.js';
import Checkout from './components/Checkout';
import { LoginStatus } from './components/LoginStatus';

import './theme/_variables.scss';

export default {
  // page components
  pageWrapper: { component: PageWrapper },
  mainHeader: { component: Header },
  mainFooter: { component: Footer },
  // contentRowsWrapper: { component: ContentRowsWrapper },
  // contentRow: { component: ContentRow },

  // contentful types
  hubCard: { component: Card },
  hubComposableCallout: { component: ComposableCallout },
  hubFeature: { component: Feature },
  headerText: { component: HeaderText },
  hubPressLogos: { component: PressLogos },
  hubProductHero: { component: ProductHero },
  hubResponsiveHeroImage: { component: ResponsiveHeroImage },
  hubStats: { component: Stats },
  hubTestimonialCarousel: { component: TestimonialCarousel },
  hubWaybetterWays: { component: WaybetterWay },
  loginStatus: { component: LoginStatus },
  hubGameCheckout: {
    component: Checkout,
    guards: [requireAuthOrProspectEmail],
  },
  link: {
    component: (fields) => <CtaButton cta={{ fields }} />,
  },
  responsiveImage: {
    component: ({ regular, ...props }) => (
      <CloudinaryImage {...{ ...props, ...flattenImageAsset(regular) }} />
    ),
  },
};
